import ApiClient from './ApiClient';

class PROFESSIONALSAPI extends ApiClient {
  constructor() {
    super('schedules/professionals', { accountScoped: true });
  }
}

export default new PROFESSIONALSAPI();
